export const strings = {
  title: 'Dergiler',
  all_journals: 'Tüm Dergiler',
  my_journals: 'Dergilerim',
  attach_journals: 'Dergi Ekleme',
  attach_journals_desc: 'Vaka ile ilgili dergiyi buraya ekleyin',
};
